import React from "react";
import { useAuth } from "@/lib/auth";
import { useI18n } from "@/lib/i18n";

export default function Settings() {
    const { merchant } = useAuth();
    const { t } = useI18n();

    return (
        <div data-testid="settings-page">
            <h1 className="font-display text-3xl font-bold tracking-tight text-[#00153f]">{t("settings_title")}</h1>
            <p className="text-gray-600 mt-1">{t("settings_sub")}</p>

            <div className="mt-8 max-w-2xl border border-gray-200 rounded-md bg-white p-6">
                <div className="grid grid-cols-3 gap-4 py-3 border-b border-gray-100">
                    <div className="text-xs font-mono uppercase tracking-widest text-gray-500">{t("name")}</div>
                    <div className="col-span-2 text-sm text-[#00153f]">{merchant?.name}</div>
                </div>
                <div className="grid grid-cols-3 gap-4 py-3 border-b border-gray-100">
                    <div className="text-xs font-mono uppercase tracking-widest text-gray-500">{t("email")}</div>
                    <div className="col-span-2 text-sm text-[#00153f]">{merchant?.email}</div>
                </div>
                <div className="grid grid-cols-3 gap-4 py-3 border-b border-gray-100">
                    <div className="text-xs font-mono uppercase tracking-widest text-gray-500">{t("company")}</div>
                    <div className="col-span-2 text-sm text-[#00153f]">{merchant?.company || "—"}</div>
                </div>
                <div className="grid grid-cols-3 gap-4 py-3">
                    <div className="text-xs font-mono uppercase tracking-widest text-gray-500">{t("settings_account_id")}</div>
                    <div className="col-span-2 text-sm text-[#00153f] font-mono">{merchant?.id}</div>
                </div>
            </div>
        </div>
    );
}
